import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Alert, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { BlockBetween, BlockHeadContent, Button, Col, Icon, RSelect } from '../Component';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_sales_rep_tenant_pending_submissions_cart, loading_retrieve_sales_rep_tenant_pending_submissions_cart, reset_retrieve_sales_rep_tenant_pending_submissions_cart, success_retrieve_sales_rep_tenant_pending_submissions_cart } from '../../reducers/auth_tenant/retrieve_sales_rep_tenant_pending_submissions_cart_Slice';
import { ADD_PRODUCT_TO_CART_ERROR_MSG, ADD_PRODUCT_TO_CART_SUCCESS_MSG, RETRIEVE_CART_LIST_ERROR_MSG, RETRIEVE_CART_LIST_SUCCESS_MSG } from '../../utils/error_success_messages';
import { ADD_PRODUCT_TO_EXISTING_ORDER_API, RETRIEVE_SPECIFIC_SALES_REP_PENDING_SUBMISSION_CART_LIST_API, SALES_REP_CREATE_ORDER_API } from '../../api/api_data';
import AuthTenantPageError from '../../pages/error/AuthTenantPageError';
import * as app_consts from "../../utils/app_consts";
import { useSelector } from 'react-redux';
import { formatNumber, getSelectedOption, messageToast } from '../../utils/Utils';
import AuthTenantLoader from '../../pages/loaders/AuthTenantLoader';
import moment from 'moment';
import { fail_sales_rep_tenant_create_order, loading_sales_rep_tenant_create_order, reset_sales_rep_tenant_create_order, success_sales_rep_tenant_create_order } from '../../reducers/auth_tenant/sales_rep_tenant_create_order_Slice';
import TextInput from '../../pages/components/inputs/TextInput';
import { fail_add_product_to_existing_order, loading_add_product_to_existing_order, reset_add_product_to_existing_order, success_add_product_to_existing_order } from '../../reducers/auth_tenant/add_product_to_existing_order_Slice';

const initialState = { order_name: "", agency_id: "", remaining_order_value: "" };

const AddToOrderModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data, product_name }) => {

  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [retrieve_add_to_cart_loading, setRetrieveAddToCartLoading] = useState(false);
  const [retrieve_add_to_cart_error, setRetrieveAddToCartError] = useState(false);
  const [add_to_existing_cart_error, setAddToExistingCartError] = useState("");
  const [selectedExstingOrder, setSelectedExistingOrder] = useState("");
  const [sales_reps_data, setSalesRepsData] = useState([]);
  const [cart_list, setCartList] = useState([]);
  const [name, setName] = useState("");
  const [add_to_existing_cart_loading, setAddToExisitingCartLoading] = useState(false);
  const [add_product_to_cart_loading, setAddProductToCartLoading] = useState(false);
  const [add_product_to_cart_error, setAddProductToCartError] = useState("");

  useEffect(() => {
    setOpen(isOpen);
    if (isOpen) 
    {
      setRetrieveAddToCartError("");
      setRetrieveAddToCartLoading(true);
      setAddToExistingCartError("");
      setSelectedExistingOrder("");
      setName(product_name);
      // Dispatch
      dispatch(tenant_auth_actions_helper(loading_retrieve_sales_rep_tenant_pending_submissions_cart, success_retrieve_sales_rep_tenant_pending_submissions_cart, fail_retrieve_sales_rep_tenant_pending_submissions_cart, RETRIEVE_CART_LIST_ERROR_MSG, RETRIEVE_CART_LIST_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_SALES_REP_PENDING_SUBMISSION_CART_LIST_API}`, data));
      setFormData(data);
    }
  }, [isOpen]);

  // Listener
  const retrieve_sales_rep_tenant_pending_submissions_cart_listener = useSelector((state) => state.retrieve_sales_rep_tenant_pending_submissions_cart.retrieve_sales_rep_tenant_pending_submissions_cart);

  useEffect(() => {
    if (retrieve_sales_rep_tenant_pending_submissions_cart_listener.status !== app_consts.IDLE)
    {
      if (retrieve_sales_rep_tenant_pending_submissions_cart_listener.status === app_consts.LOADING)
      {
        setRetrieveAddToCartLoading(true);
        setRetrieveAddToCartError("");
      } else
      {
        setRetrieveAddToCartLoading(false);
        if (retrieve_sales_rep_tenant_pending_submissions_cart_listener.status === app_consts.FAIL)
        {
          setRetrieveAddToCartError(retrieve_sales_rep_tenant_pending_submissions_cart_listener.message);
          messageToast(retrieve_sales_rep_tenant_pending_submissions_cart_listener.message, app_consts.FAIL);
        } else if (retrieve_sales_rep_tenant_pending_submissions_cart_listener.status === app_consts.SUCCESS)
        {
          const remapped_sales_reps = retrieve_sales_rep_tenant_pending_submissions_cart_listener.data?.sales_rep_agencies?.map((rep) => {
            return {
              label: `${rep?.name} - ${rep?.mobile_number}`,
              value: rep?.id,
              remaining_order_value: rep?.remaining_order_value
            };
          });
          setSalesRepsData(remapped_sales_reps);
          setCartList(retrieve_sales_rep_tenant_pending_submissions_cart_listener.data);
        }
        dispatch(reset_retrieve_sales_rep_tenant_pending_submissions_cart());
      }
    }
  }, [retrieve_sales_rep_tenant_pending_submissions_cart_listener]);



  // Create Destination
  const create_cart_destination = () => {
    setAddProductToCartError("");
    setAddToExistingCartError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_sales_rep_tenant_create_order, success_sales_rep_tenant_create_order, fail_sales_rep_tenant_create_order, ADD_PRODUCT_TO_CART_ERROR_MSG, ADD_PRODUCT_TO_CART_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${SALES_REP_CREATE_ORDER_API}`, formData));
  };

  const retrieve_sales_rep_tenant_create_order = useSelector((state) => state.sales_rep_tenant_create_order.sales_rep_tenant_create_order);

  useEffect(() => {
    if (retrieve_sales_rep_tenant_create_order.status !== app_consts.IDLE)
    {
      if (retrieve_sales_rep_tenant_create_order.status === app_consts.LOADING)
      {
        setAddProductToCartLoading(true);
        setAddProductToCartError("");
      } else
      {
        setAddProductToCartLoading(false);
        if (retrieve_sales_rep_tenant_create_order.status === app_consts.FAIL)
        {
          setAddProductToCartError(retrieve_sales_rep_tenant_create_order.message);
          messageToast(retrieve_sales_rep_tenant_create_order.message, app_consts.FAIL);
        } else if (retrieve_sales_rep_tenant_create_order.status === app_consts.SUCCESS)
        {
          messageToast(retrieve_sales_rep_tenant_create_order.data, app_consts.SUCCESS);
          successFunction();
        }
        dispatch(reset_sales_rep_tenant_create_order());
      }
    }
  }, [retrieve_sales_rep_tenant_create_order]);



  const add_to_existing_cart = (order_ref_number) => {
    setAddProductToCartError("");
    setAddToExistingCartError("");
    setSelectedExistingOrder(order_ref_number);
    const new_formData = { ...formData, ["order_ref_number"]: order_ref_number };
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_add_product_to_existing_order, success_add_product_to_existing_order, fail_add_product_to_existing_order, ADD_PRODUCT_TO_CART_ERROR_MSG, ADD_PRODUCT_TO_CART_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADD_PRODUCT_TO_EXISTING_ORDER_API}`, new_formData));
  };

  const retrieve_add_product_to_existing_order = useSelector((state) => state.add_product_to_existing_order.add_product_to_existing_order);

  useEffect(() => {
    if (retrieve_add_product_to_existing_order.status !== app_consts.IDLE)
    {
      if (retrieve_add_product_to_existing_order.status === app_consts.LOADING)
      {
        setAddToExisitingCartLoading(true);
        setAddToExistingCartError("");
      } else
      {
        setAddToExisitingCartLoading(false);
        if (retrieve_add_product_to_existing_order.status === app_consts.FAIL)
        {
          setAddToExistingCartError(retrieve_add_product_to_existing_order.message);
          messageToast(retrieve_add_product_to_existing_order.message, app_consts.FAIL);
        } else if (retrieve_add_product_to_existing_order.status === app_consts.SUCCESS)
        {

          successFunction();
          messageToast(ADD_PRODUCT_TO_CART_SUCCESS_MSG, app_consts.SUCCESS);
        }
        dispatch(reset_add_product_to_existing_order());
      }
    }
  }, [retrieve_add_product_to_existing_order]);

  return (
    <>
      <Modal isOpen={open} toggle={loading || retrieve_add_to_cart_loading ? "" : closeModal} size="lg" scrollable centered>
        <ModalHeader toggle={loading || retrieve_add_to_cart_loading ? "" : closeModal}>
          Add to Order - {name}
        </ModalHeader>
        <ModalBody>
          {
            loading || retrieve_add_to_cart_loading ? (
              <>
                <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Order(s) Data..." />
              </>
            )
              :
              <>
                {
                  retrieve_add_to_cart_error && retrieve_add_to_cart_error?.length > 0 ?
                    <>
                      <AuthTenantPageError tenant_info={tenant_info} error_message={retrieve_add_to_cart_error} />
                    </>
                    :
                    <>
                      <div className="order-summary mb-4 p-3 bg-light rounded">
                        <h6 className="mb-3">Order Summary</h6>
                        <div className="summary-grid">
                          <div className="summary-item">
                            <span>Product:</span>
                            <span>{name}</span>
                          </div>
                          <div className="summary-item">
                            <span>Quantity:</span>
                            <span>{formData?.units}</span>
                          </div>
                          <div className="summary-item">
                            <span>Total Value:</span>
                            <span className="fw-bold">{formData?.total_value} ZMW</span>
                          </div>
                        </div>
                      </div>
                      {cart_list?.orders?.length > 0 ? (
                        <>
                          <h6 className="mb-3">Add to Existing Order</h6>
                          <div className="existing-orders-list">
                            {cart_list.orders.map((order, index) => (
                              <>
                                {add_to_existing_cart_error && selectedExstingOrder === order?.order_ref_number && (
                                  <Alert color="danger" className="alert-icon">
                                    <Icon name="alert-circle" /> {add_to_existing_cart_error}
                                  </Alert>
                                )}
                                <div key={index} className={`order-item ${selectedExstingOrder === order.order_ref_number ? 'selected' : ''}`}>

                                  <div className="order-info">
                                    <div className="order-ref">{order.order_ref_number}</div>
                                    <div className="order-name">{order.order_name}</div>
                                    <div className="order-meta">
                                      <span>{moment(order.inserted_at).format('LL')}</span>
                                      <span>{order.products_count} items</span>
                                    </div>
                                  </div>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => add_to_existing_cart(order.order_ref_number)}
                                    disabled={add_to_existing_cart_loading || add_product_to_cart_loading}
                                  >
                                    {add_to_existing_cart_loading && selectedExstingOrder === order.order_ref_number ? (
                                      <Spinner size="sm" />
                                    ) : (
                                      'Select'
                                    )}
                                  </Button>
                                </div>
                              </>
                            ))}
                          </div>
                          <div className="divider-with-text my-4">
                            <span>OR</span>
                          </div>
                        </>
                      ) : (
                        <div className="text-center py-3">
                          <Icon name="package" size="2x" className="text-muted mb-2"></Icon>
                          <p className="text-muted">You don't have any active orders yet</p>
                        </div>
                      )}

                      <h6 className="mb-3">Create New Order</h6>
                      {add_product_to_cart_error && (
                        <Col xs={12}>
                          <Alert color="danger" className="alert-icon">
                            <Icon name="alert-circle" /> {add_product_to_cart_error}
                          </Alert>
                        </Col>
                      )}
                      <div className="new-order-form my-2">
                        <TextInput
                          label="Order Name/Destination"
                          type="text"
                          colSize={12}
                          value={formData?.order_name}
                          placeholder="Add Destination..."
                          name="order_name"
                          parentClassName=" flex-grow-1 my-1"
                          handleChange={(e) =>
                            setFormData({
                              ...formData,
                              order_name: e.target.value,
                            })
                          }
                        />
                        <Col lg={12}>
                          <div className="form-group">
                            <div className="form-label-group">
                              <label className="form-label">
                                <label className="form-label mb text-md" htmlFor="retrunable">
                                  Select Agency<span className='text-danger pr-2'>{` *`}</span>
                                </label>
                              </label>
                            </div>
                            <div className="w-100">
                              <RSelect
                                options={sales_reps_data}
                                className="w-100"
                                placeholder="Search"
                                value={getSelectedOption(formData?.agency_id, sales_reps_data)}
                                onChange={(e) => setFormData({ ...formData, agency_id: e.value, remaining_order_value: e?.remaining_order_value })}
                              />
                            </div>
                          </div>
                        </Col>
                        {
                          formData?.agency_id && (
                            <>
                              <TextInput
                                label="Order Allocation Balance"
                                type="text"
                                colSize={12}
                                value={formData?.remaining_order_value ? `${formatNumber(formData?.remaining_order_value)} ZMW` : "--"}
                                name="remaining_order_value"
                                parentClassName=" flex-grow-1 my-1"
                                disabled
                              />
                            </>
                          )
                        }
                        <div className="d-flex justify-content-end mt-4">
                          <Button
                            color="primary"
                            onClick={create_cart_destination}
                            disabled={add_product_to_cart_loading || add_to_existing_cart_loading || !(formData?.agency_id && formData?.color && formData?.packet_size && (formData?.returnable ? formData?.return_date : true) && formData?.units && formData?.order_name)}
                          >
                            {add_product_to_cart_loading ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                                Creating...
                              </>
                            ) : (
                              'Create New Order'
                            )}
                          </Button>
                        </div>
                      </div>
                    </>
                }
              </>
          }
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <div>
              <Button
                className="me-2"
                disabled={loading || retrieve_add_to_cart_loading}
                onClick={closeModal}
                color="gray"
              >
                Close
              </Button>
              {/* Add any additional left-aligned buttons here */}
            </div>
            <div>
              {/* Right-aligned buttons would go here */}
            </div>
          </div>
        </ModalFooter>
      </Modal>

    </>
  );
};

// Add this CSS to your styles
const styles = `
  .order-summary {
    border: 1px solid #e5e9f2;
    border-radius: 4px;
  }

  .summary-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
  }

  .summary-item {
    display: flex;
    justify-content: space-between;
  }

  .existing-orders-list {
    max-height: 300px;
    overflow-y: auto;
  }

  .order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border: 1px solid #e5e9f2;
    border-radius: 4px;
    margin-bottom: 0.75rem;
    transition: all 0.3s;
  }

  .order-item.selected {
    border-color: #6576ff;
    background-color: rgba(101, 118, 255, 0.05);
  }

  .order-info {
    flex: 1;
  }

  .order-ref {
    font-size: 0.8rem;
    color: #8a99b5;
    margin-bottom: 0.25rem;
  }

  .order-name {
    font-weight: 500;
    margin-bottom: 0.25rem;
  }

  .order-meta {
    display: flex;
    gap: 1rem;
    font-size: 0.8rem;
    color: #8a99b5;
  }

  .divider-with-text {
    display: flex;
    align-items: center;
    text-align: center;
    color: #8a99b5;
  }

  .divider-with-text::before,
  .divider-with-text::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #e5e9f2;
  }

  .divider-with-text::before {
    margin-right: 1rem;
  }

  .divider-with-text::after {
    margin-left: 1rem;
  }
`;

// Add the styles to the document head
const styleElement = document.createElement('style');
styleElement.innerHTML = styles;
document.head.appendChild(styleElement);

export default AddToOrderModal;